module.exports = __webpack_public_path__ + "static/media/brake-inspection.bc0e20ca.svg";